import { NodeModel } from '@minoru/react-dnd-treeview';
import { DownloadReportsModel } from '../../models/downloadReports.model';
import { LanguageModel } from '../../models/i18n.model';
import {
    InterruptionModel,
    InterruptionsListModel,
} from '../../models/interruptions/interruptionList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    langResources: LanguageModel;
    interruptionList: InterruptionsListModel;
    downloadReport: (
        body: DownloadReportsModel,
        msgLoading: string | undefined,
        msgSuccess: string | undefined,
        msgError: string | undefined,
        msgAlert: string,
        msgFile: string,
        urlAPI: string
    ) => void;
    getInterruptionsList: (
        startDate: string,
        endDate: string,
        employeeID: string | number,
        interruptionList: InterruptionsListModel
    ) => InterruptionModel[];
};

export const controllerPrintInterruptionsModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    interruptionList,
    langResources,
    downloadReport,
    getInterruptionsList,
}: Props) => {
    let recoveredData = window.localStorage.getItem('selection-range');

    if (recoveredData) {
        let data: Array<{
            employeeId: string | number;
            text: string;
            date: string;
        }> = JSON.parse(recoveredData);
        if (data.length > 0) {
            let interruptions: number[] = [];

            data.forEach(({ date, employeeId }) => {
                let interruption = getInterruptionsList(
                    date,
                    date,
                    employeeId,
                    interruptionList
                );

                interruption.forEach((interr) => {
                    interruptions.push(interr.id);
                });
            });

            let body: DownloadReportsModel = {
                interruptionIds: interruptions,
            };

            downloadReport(
                body,
                undefined,
                undefined,
                undefined,
                langResources['reports.message.alert'],
                langResources['work.permit.report.filename'],
                '/reports/permit-applications'
            );
        }
    } else {
        let row1 = grid.selectedRanges[0].row;
        let row2 = grid.selectedRanges[0].row2;
        let col1 = grid.selectedRanges[0].col - 2;
        let col2 = grid.selectedRanges[0].col2 - 2;

        if (row1 > row2) {
            let aux = row1;
            row1 = row2;
            row2 = aux;
        }

        if (col1 > col2) {
            let aux = col1;
            col1 = col2;
            col2 = aux;
        }

        let initDate = getDatesBetweenDates(startDate, endDate)[col1];
        let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

        let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

        let interruptions: number[] = [];

        for (let emp = 0; emp < selectedEmployees.length; emp++) {
            let interruption = getInterruptionsList(
                initDate,
                lastDate,
                selectedEmployees[emp].id,
                interruptionList
            );

            interruption.forEach((interr) => {
                interruptions.push(interr.id);
            });
        }

        let body: DownloadReportsModel = {
            interruptionIds: interruptions,
        };

        if (interruptions.length > 0) {
            downloadReport(
                body,
                undefined,
                undefined,
                undefined,
                langResources['reports.message.alert'],
                langResources['work.permit.report.filename'],
                '/jerusalem/api/v2.0.0/reports/permit-applications'
            );
        }
    }
};
